import './styles.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Arrow extends Component {
  static propTypes = {
    dir: PropTypes.string
  }

  render () {
    const { dir, stroke } = this.props

    return (
      <svg
        x='0px'
        y='0px'
        stroke={stroke}
        viewBox='0 0 14 8'
        xmlSpace='preserve'
        fill='none'
        className={`menu-arrow generic-arrow generic-arrow-${dir}`}
      >
        <path d='M1,1l6.2,6L13,1' />
      </svg>
    )
  }
}
